import React from 'react'
import PropTypes from 'prop-types'

import { FilterChip as Chip, Flex, Text, Truncate } from 'pcln-design-system'

const SecondaryLabelText = Text

const ChipFilterItem = ({
  checked,
  chipId,
  className,
  dataAutobotElementId,
  disabled,
  primaryIcon,
  primaryLabel,
  primaryLabelIcon,
  repeatIconByFactor,
  secondaryLabel,
  showActionIcon,
  updateSelection,
}) => {
  const chipSecondaryLabel = secondaryLabel?.toString()

  return (
    <Chip
      className={className}
      data-autobot-element-id={dataAutobotElementId}
      disabled={Boolean(disabled)}
      height={32}
      id={chipId}
      onClick={updateSelection}
      px={1}
      selected={Boolean(checked)}
      showActionIcon={showActionIcon && Boolean(checked)}
    >
      <Flex alignItems='center' justifyContent='center'>
        {!repeatIconByFactor && primaryIcon}

        {!primaryIcon &&
          primaryLabelIcon &&
          typeof primaryLabelIcon !== 'string' &&
          !repeatIconByFactor &&
          React.cloneElement(primaryLabelIcon, {
            color: disabled ? 'text.light' : 'primary.base',
            ml: 1,
            size: 20,
          })}

        {repeatIconByFactor && (
          <Text.span
            color={disabled ? 'text.light' : 'primary.base'}
            fontSize={0}
            ml={2}
            mr={chipSecondaryLabel ? 0 : 2}
            regular
          >
            {repeatIconByFactor} Star
            {repeatIconByFactor === 1 ? ' & below' : 's'}
          </Text.span>
        )}

        {primaryLabel && !repeatIconByFactor && (
          <Truncate color={disabled ? 'text.light' : 'primary.base'}>
            <Text.span
              color={disabled ? 'text.light' : 'primary.base'}
              fontSize={0}
              ml={2}
              mr={chipSecondaryLabel ? 0 : 2}
              regular
            >
              {primaryLabel}
            </Text.span>
          </Truncate>
        )}

        {chipSecondaryLabel && (
          <SecondaryLabelText
            color={disabled ? 'text.light' : 'primary.base'}
            fontSize={0}
            minWidth={33}
            regular
            textAlign='center'
          >
            ({chipSecondaryLabel})
          </SecondaryLabelText>
        )}
      </Flex>
    </Chip>
  )
}

ChipFilterItem.propTypes = {
  checked: PropTypes.bool,
  chipId: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  dataAutobotElementId: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  primaryIcon: PropTypes.node,
  primaryLabel: PropTypes.string,
  primaryLabelIcon: PropTypes.node,
  repeatIconByFactor: PropTypes.number,
  secondaryLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showActionIcon: PropTypes.bool,
  updateSelection: PropTypes.func,
  value: PropTypes.string,
}

ChipFilterItem.defaultProps = {
  disabled: false,
  primaryIcon: null,
}

export default ChipFilterItem
